<template>
    <div v-loading="isBusy">
        <el-row v-if="initialized">
            <el-col :span="6" v-for="(col, index) in columns" :key="`job-snippet-headline-${index}`"><h2>{{ getTitle(col) }}</h2></el-col>
        </el-row>

        <el-row v-if="initialized" v-for="snippet in snippetOptions" :key="`job-snippet-${snippet.id}`" style="margin-bottom:20px">
            <el-col :span="6" v-for="(col, index) in columns" :key="`job-snippet-${snippet.id}-${index}`" style="padding:5px;">
                <template v-if="col">
                    <label>{{ snippet.name }}</label>
                    <el-input v-if="col === 'job'"
                              v-model="formValues[col][snippet.id].value"
                              type="textarea"
                              @input="updateFormValues"
                              :maxlength="snippet.id === 'salary' ? 10 : 255"></el-input>
                    <el-input v-else
                              v-model="formValues[col][snippet.id]"
                              type="textarea"
                              @input="updateFormValues"
                              :placeholder="col === 'employer' ? snippet.help : ''"
                              :maxlength="snippet.id === 'salary' ? 10 : 255"></el-input>

                    <div v-if="col === 'job'" style="margin-top:5px;">
                        <el-checkbox v-model="formValues[col][snippet.id].is_appended" @input="updateFormValues">
                            Append to snippet
                        </el-checkbox>
                    </div>
                </template>
                <template v-else></template>
            </el-col>

            <el-col :span="24">
                <span style="padding:5px;">{{ snippet.name }}: {{ getNonEmptyValue(snippet.id) }}</span>
                <hr/>
            </el-col>
        </el-row>
    </div>
</template>

<script>
export default {
    props: [
        'job_id',
        'job_data',
        'employer_id',
        'value',
    ],
    data() {
        return {
            isBusy: false,
            initialized: false,
            snippetOptions: [],
            routeCategories: [],
            driverCategories: [],
            categories_name: [],
            formValues: this.value,
        };
    },
    computed: {
        driverType: function () {
            return this.getType('Job Category', this.driverCategories);
        },
        routeType: function () {
            return this.getType('Driving Distance', this.routeCategories);
        },
        columns: function () {
            return [
                'employer',
                this.driverType,
                this.routeType,
                'job',
            ];
        },
    },
    mounted() {
        this.loadData().then(response => {
            this.initialized = true;
        });
    },
    methods: {
        updateFormValues() { this.$emit('input', this.formValues); },
        loadData() {
            this.isBusy = true;
            return axios.get(url(`/admin/employer/${this.employer_id}/get-snippet-data?job_id=${this.job_id}`))
                        .then(response => {
                            this.snippetOptions = response.data.snippets;
                            this.routeCategories = response.data.route_categories;
                            this.driverCategories = response.data.driver_categories;
                            this.categories_name = response.data.categories_name;
                            this.formValues = response.data.values;
                            this.updateFormValues();
                            this.isBusy = false;
                        });
        },
        getTitle(column) {
            if (!column) return 'Not selected';

            switch(column) {
                case 'employer':
                    return 'Employer';

                case 'lease_purchase':
                case 'owner_operators':
                case 'company_drivers':
                    return `Driver (${this.categories_name[column]})`;

                case 'local':
                case 'dedicated':
                case 'regional':
                case 'otr':
                    return `Route (${this.categories_name[column]})`;

                case 'job':
                    return 'Job Specific';
            }
        },
        getType(typeName, categories) {
            if (categories.length === 0 || typeof this.job_data[typeName] === 'undefined') return null;

            for(let i = 0; i < categories.length; i++) {
                let categoryName = this.categories_name[categories[i]];

                let checkbox = _.filter(this.job_data[typeName], function (ch) {
                    return ch.name === categoryName && ch.checked === true;
                });

                if (checkbox.length === 0) continue;
                return categories[i];
            }

            return null;
        },
        getNonEmptyValue(snippetId) {
            let result = '';

            const cols = _.reverse(_.clone(this.columns));
            for(let i = 0; i < cols.length; i++) {
                let val = null;
                if (cols[i] === 'job' && !this.formValues[cols[i]][snippetId].is_appended) {
                    val = this.formValues['job'][snippetId].value;
                } else if (cols[i] !== 'job' && this.formValues[cols[i]]) {
                    val = this.formValues[cols[i]][snippetId];
                }
                val = val == null ? '' : val;
                if (!val.trim()) continue;
                result += val;
                break;
            }

            if (this.formValues['job'][snippetId].is_appended && this.formValues['job'][snippetId].value != null) {
                result += this.formValues['job'][snippetId].value;
            }

            if (!result.trim()) return '';
            return result;
        },
    },
};
</script>

<style scoped>
</style>